import React from 'react';
import {useDispatch} from 'react-redux';
import styled from 'styled-components';
import {SVGICONS} from '@ey/icons';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {IconoirCustomEstimate} from '@ey/motif-react-wrapper/assets/icons/custom';
import {labels} from '../../../../../../../util/utils';
import {documentTypes, entities, ViewKeys} from '../../../../../../../util/uiconstants';
import CreateEntityForm from '../../../Common/CreateEntityForm/CreateEntityForm';
import {setFormV2ToasterVisibility} from '../../../../../../../actions/toastactions';
import AccountExecutionType from '../../../../../Accounts/AccountExecutionType/AccountExecutionType';
import RelatedDocumentsTooltip from './RelatedDocumentsTooltip';

export default function AccountNameWithCreate(props) {
	const {name, relatedDocuments, hasEstimate, executionTypeId, accountId} = props;
	const dispatch = useDispatch();

	const handleCreateDocument = () => {
		dispatch(setFormV2ToasterVisibility(true, 'info', labels.documentCreationSuccessMsg));
	};

	return (
		<StyledAccountNameWrapper className="StyledAccountNameWrapper">
			{relatedDocuments && relatedDocuments.length > 0 ? (
				<RelatedDocumentsTooltip
					relatedDocuments={relatedDocuments}
					name={name}
					hasEstimate={hasEstimate}
					executionTypeId={executionTypeId}
					title={labels.ALRARelatedDocuments}
				/>
			) : (
				<StyledAccountNameWithCreate className="StyledAccountNameWithCreate">
					<span className="account-name">
						<CreateEntityForm
							key={`createEntityAccount-${accountId}`}
							createLabel={name}
							entityId={entities.Account}
							objectIds={[accountId]}
							documentTypeId={documentTypes.ALRA_INDIVIDUAL}
							viewKey={ViewKeys.Account}
							showIcon={false}
							showDocuments={false}
							showLoading={false}
							onCreateDocument={handleCreateDocument}
						/>
					</span>
					<AccountExecutionType executionTypeId={executionTypeId} />
					{hasEstimate && (
						<MotifIcon
							className="medium estimate-icon"
							title={labels.estimate}
							iconFunction={IconoirCustomEstimate}
							size="24"
						/>
					)}
				</StyledAccountNameWithCreate>
			)}
		</StyledAccountNameWrapper>
	);
}

const StyledAccountNameWrapper = styled.section``;

const StyledAccountNameWithCreate = styled.section`
	display: flex;
	align-items: center;
	width: 100%;
	color: var(--neutrals-900);
	.account-name {
		display: flex;
		justify-content: flex-start;
		width: auto;
		max-width: calc(100% - var(--px-100));
		.StyledCreate {
			width: 100%;
			.StyledCreateLabel {
				width: 100%;
				font-weight: 400;
			}
		}
	}
	.estimate-icon {
		display: flex;
		justify-content: flex-end;
		margin-left: auto;
		color: var(--neutrals-900);
		svg {
			height: var(--px-24);
			width: var(--px-24);
			color: var(--neutrals-900);
			path {
				fill: currentColor;
			}
		}
	}
`;
